import { allowedExtensionsFile, allowedExtensionsImage } from "./Helper";

export const getFileExtension=(fileName:string)=>{
    return fileName.split(".").pop();
}
export const GetTypeFile=(extension:string)=>{
    if(allowedExtensionsFile?.includes(extension.toLowerCase()))
        return "file";
    else if(allowedExtensionsImage?.includes(extension.toLowerCase()))
        return "image";
    else
        return null;
}

export const getFileNameWithoutExtsnions=(fileName: string)=>{
    const nameWithoutExtension = fileName?.split('.')?.slice(0, -1)?.join('.');
    return nameWithoutExtension.length > 10 ? nameWithoutExtension.substring(0, 10) + "..." : nameWithoutExtension;
}


export const  FileUploadMaxSize=10 * 1024 * 1024;

